"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrchardBrands = exports.ItemTypes = exports.AddonTypes = void 0;
var AddonTypes;
(function (AddonTypes) {
    AddonTypes["FB_PIXEL"] = "FB_PIXEL";
    AddonTypes["METADATA"] = "METADATA";
    AddonTypes["CUSTOM_IMAGE"] = "CUSTOM_IMAGE";
    AddonTypes["APPRECIATION_ENGINE"] = "APPRECIATION_ENGINE";
    AddonTypes["AGE_GATE"] = "AGE_GATE";
    AddonTypes["THEME"] = "THEME";
    AddonTypes["AUTH_GATE"] = "AUTH_GATE";
    AddonTypes["BUTTON_STYLE"] = "BUTTON_STYLE";
    AddonTypes["LAYOUT_SETTINGS"] = "LAYOUT_SETTINGS";
    // TODO: remove this once songwhip-web no longer depending on it
    AddonTypes["EXCLUSIVE_CONTENT"] = "EXCLUSIVE_CONTENT";
})(AddonTypes || (exports.AddonTypes = AddonTypes = {}));
var ItemTypes;
(function (ItemTypes) {
    ItemTypes["ARTIST"] = "artist";
    ItemTypes["ALBUM"] = "album";
    ItemTypes["TRACK"] = "track";
    ItemTypes["VIDEO"] = "video";
    ItemTypes["CUSTOM_PAGE"] = "customPage";
})(ItemTypes || (exports.ItemTypes = ItemTypes = {}));
var OrchardBrands;
(function (OrchardBrands) {
    OrchardBrands["ORCHARD"] = "orchard";
    OrchardBrands["AWAL"] = "awal";
    OrchardBrands["SME"] = "sme";
})(OrchardBrands || (exports.OrchardBrands = OrchardBrands = {}));
//# sourceMappingURL=sharedTypes.js.map